<template>
    <div id="map"></div>
</template>

<script>
    export default {
        data () {
            return {
                center: {
                    lat: 42.679845,
                    lng: 23.330846
                },
                infoContent: '',
                infoWindowPos: {
                    lat: 0,
                    lng: 0
                },
                infoWinOpen: false,
                currentMidx: null,
                infoOptions: {
                    pixelOffset: {
                        width: 0,
                        height: -65
                    }
                },
                styles: [
                    {
                        'featureType': 'administrative',
                        'elementType': 'labels.text.fill',
                        'stylers': [{
                            'color': '#444444'
                        }]
                    }, {
                        'featureType': 'landscape',
                        'elementType': 'all',
                        'stylers': [{
                            'color': '#f2f2f2'
                        }]
                    }, {
                        'featureType': 'poi',
                        'elementType': 'all',
                        'stylers': [{
                            'visibility': 'off'
                        }]
                    }, {
                        'featureType': 'road',
                        'elementType': 'all',
                        'stylers': [{
                            'saturation': -100
                        }, {
                            'lightness': 45
                        }]
                    }, {
                        'featureType': 'road.highway',
                        'elementType': 'all',
                        'stylers': [{
                            'visibility': 'simplified'
                        }]
                    }, {
                        'featureType': 'road.arterial',
                        'elementType': 'labels.icon',
                        'stylers': [{
                            'visibility': 'off'
                        }]
                    }, {
                        'featureType': 'transit',
                        'elementType': 'all',
                        'stylers': [{
                            'visibility': 'off'
                        }]
                    }, {
                        'featureType': 'water',
                        'elementType': 'all',
                        'stylers': [{
                            'color': '#6dcff6'
                        }, {
                            'visibility': 'on'
                        }]
                    }
                ],
                markers: [
                    {
                        position: {
                            lat: 42.679845,
                            lng: 23.330846
                        },
                        infoText: '<h2>Bimbi</h2><p>ул. Янко Софийски войвода 21</p>',
                        icon: '/static/images/pin.png'
                    }
                ]
            }
        },
        methods: {
            toggleInfoWindow: function (marker, idx) {
                this.infoWindowPos = marker.position
                this.infoContent = marker.infoText
                if (this.currentMidx === idx) {
                    this.infoWinOpen = !this.infoWinOpen
                } else {
                    this.infoWinOpen = true
                    this.currentMidx = idx
                }
            }
        },
        mounted () {
            window.initMap()
        }
    }
</script>

<style>
    #map {
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Map.vue?595c5605